import React from 'react';
import Chip from '@material-ui/core/Chip';
import clsx from 'clsx';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { VaccineApprovalStatus } from 'model/VaccineApproval';

const useStyles = makeStyles(() =>
    createStyles({
        chip: {
            'display': 'inline-flex',
            'height': 27,
            'padding': '4px 11px',
            'justifyContent': 'center',
            'alignItems': 'center',
            'gap': 5,
            'borderRadius': 100,
            'textAlign': 'center',
            'fontFeatureSettings': "'liga' off, 'clig' off",
            'fontFamily': 'Poppins, sans-serif',
            'fontSize': 14,
            'fontStyle': 'normal',
            'fontWeight': 500,
            'lineHeight': '20px',
            'textTransform': 'capitalize',
            'transform': 'none',
            'position': 'relative',
            '& .MuiChip-label': {
                padding: 0,
                overflow: 'visible'
            }
        },
        approved: {
            background: '#E9F0ED',
            color: '#5E8677'
        },
        declined: {
            background: '#FFE5E7',
            color: '#CC444B'
        }
    })
);

interface VaccineApprovalStatusChipProps {
    status: Exclude<VaccineApprovalStatus, 'pending'>;
    className?: string;
}

const VaccineApprovalStatusChip: React.FC<VaccineApprovalStatusChipProps> = ({ status, className }) => {
    const classes = useStyles();
    const label = status === 'approved' ? 'Approved' : 'Declined';

    return (
        <Chip
            className={clsx(classes.chip, classes[status], className)}
            label={label}
        />
    );
};

export default VaccineApprovalStatusChip;
